import React from 'react';
import TextField from '@mui/material/TextField';
import FieldLabel from '../components/FieldLabel';
import { getFieldLabel } from '../utils/formHelpers';
import { todayDateOnlyString, isUnchangedSavedDate } from '../../wizard/utils/formHelpers';
import { outlinedFieldProps } from '../utils/fieldStyles';

const toDateInputValue = (v) => {
    if (!v) return '';
    // Handles "2026-09-30", "2026-09-30T00:00:00", "2026-09-30 00:00:00", etc.
    const normalized = String(v).includes('T') ? String(v) : String(v).replace(' ', 'T');
    return normalized.slice(0, 10);
};

/** Pick the tighter (later) of two YYYY-MM-DD mins, or earlier of two maxes. */
const tighterMin = (a, b) => {
    if (!a) return b;
    if (!b) return a;
    return a >= b ? a : b;
};
const tighterMax = (a, b) => {
    if (!a) return b;
    if (!b) return a;
    return a <= b ? a : b;
};

const DateField = ({ field, data, change, hasError, errorMessage }) => {
    const boundMin = field.minFromField && data[field.minFromField]
        ? toDateInputValue(data[field.minFromField])
        : undefined;
    const boundMax = field.maxFromField && data[field.maxFromField]
        ? toDateInputValue(data[field.maxFromField])
        : undefined;
    const afterMin = field.validateAfter && data[field.validateAfter]
        ? toDateInputValue(data[field.validateAfter])
        : undefined;
    // Inclusive lower bound from a sibling date (e.g. season_to >= season_from).
    const onOrAfterMin = field.validateOnOrAfter && data[field.validateOnOrAfter]
        ? toDateInputValue(data[field.validateOnOrAfter])
        : undefined;
    const beforeMax = field.validateOnOrBefore && data[field.validateOnOrBefore]
        ? toDateInputValue(data[field.validateOnOrBefore])
        : undefined;
    const todayMin = field.disallowPast && !isUnchangedSavedDate(data, field.key, data[field.key])
        ? todayDateOnlyString()
        : undefined;

    // validateAfter is exclusive (>); HTML min is inclusive, so bump by one day is
    // awkward — keep exclusive checks in validation; for the picker use onOrAfter.
    const minDate = tighterMin(todayMin, tighterMin(boundMin, tighterMin(onOrAfterMin, afterMin)));
    const maxDate = tighterMax(boundMax, beforeMax);

    return (
        <TextField
            {...outlinedFieldProps}
            label={<FieldLabel label={getFieldLabel(field)} tooltip={field.tooltip} />}
            type="date"
            value={toDateInputValue(data[field.key])}
            onChange={(e) => change(field.key, e.target.value)}
            error={hasError}
            helperText={hasError ? (errorMessage || 'This field is required') : ''}
            InputLabelProps={{ shrink: true }}
            inputProps={{
                ...(minDate ? { min: minDate } : {}),
                ...(maxDate ? { max: maxDate } : {}),
            }}
        />
    );
};

export default DateField;
